class BESSAppProjectDependencyType {
    static projectQAValue = 1;
    static siteType = 2;
    static hasItems = 3;
    static projectQAValueIsAnswered = 4;
    static creditIsEnabled = 5;
    static itemQAValue =6;
    static itemQASelected = 7;
}
